import styled from 'styled-components';
import MUIContainer from '@material-ui/core/Container';

export const Container = styled(MUIContainer)`
  display: flex;
  align-items: center;
  justify-content: center;
`;
